import React from 'react'
import { images } from '../../images'
import StyledSection from './styles'
import { StopMarker } from '../StopMarker'
import theme from '../../theme'
import { StopsRouteDots } from '../StopsRouteDots'

interface IProps {
  inStopName: string
  outStopName: string
  noColors?: boolean
}

export const StopsCard: React.FC<IProps> = ({ inStopName, outStopName, noColors }) => {
  return (
    <StyledSection>
      <div className="column-details">
        <StopsRouteDots
          colorStart={ noColors ? theme.colors.black : theme.colors.blueLight }
          colorEnd={ noColors ? theme.colors.black : theme.colors.greenRadio }
          horizontal={ false }
        />
      </div>
      <div className="column-details">
        <span className="stop-name">
          { inStopName }
        </span>
        <span className="stop-name">
          { outStopName }
        </span>
      </div>
    </StyledSection>
  )
}
